export default __webpack_public_path__ + "static/media/germany-flag-icon.d9625f93.svg";